
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/Hooks/useComId.html",
      function () {
        return require("private-next-pages/Hooks/useComId.html.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/Hooks/useComId.html"])
      });
    }
  